var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row start"},[_c('div',{staticClass:"wf flex-row left"},[_vm._v(_vm._s(_vm.value.Name))]),_c('div',{staticClass:"flex-row w100 right"},[_c('div',[_vm._v("题目数量:")]),_c('div',{staticClass:"active"},[_vm._v(_vm._s(_vm.value.TopicCount))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }